import { fetchHandler, fetchHandlerForm } from "../Handler/Handler";


export const POSTVendorCategory = async (slugname, data) => {
    try {
        const response = await fetchHandler({
            method: "POST",

            endpoint: `/category/vendor/${slugname}/newcategory`,
            data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const UpdateCatgoryVendor = async (slugname, data, id) => {
    try {
        const response = await fetchHandler({
            method: "PUT",
            endpoint: `/category/vendor/${slugname}/updatecategory/${id}`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const UpdatestatusVendorCatergoery = async (slugname, data, id) => {
    try {

        const response = await fetchHandler({
            method: "PATCH",
            endpoint: `/category/vendor/${slugname}/status/${id}`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const GetVendorCategory = async (slugname) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/category/vendor/${slugname}/categories`,
            data: null
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const GETVendor = async (slugname) => {
    try {
        const response = await fetchHandler({
            method: "GET",
            endpoint: `/vendor/${slugname}/products/`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const DELETECategory = async (slugname, id) => {
    try {
        const response = await fetchHandler({
            method: "DELETE",
            endpoint: `/category/vendor/${slugname}/deletecategory/${id}`,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const GETSingleCategory = async (slugname, id,) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/category/vendor/${slugname}/categories/${id}`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
